import $ from 'gridstrap/lib/gs-zepto';
import * as locale from 'gridstrap/lib/gs-locale';

import article = require('indefinite');

export class GSFormLocaleChangePrompt {

	//
	// Properties
	//

	private root;
	private form;
	private countries;
	private label;

	get isVisible()      { return !this.root.hasClass('d-none'); }
	set isVisible(value) { this.root.toggleClass('d-none', !value); }

	//
	// Methods
	//

	showCountryList() {
		this.isVisible = false;
		this.countries.isVisible = true;
		this.countries.focus();
	}

	detectCountry() {
			this.countries.code = locale.get();
			this.setLabel();
			this.isVisible = true;
	}

	setLabel() {
		let { code, name, adjective } = this.countries;
		let country = article(adjective || name); // prepend "a" or "an"

		// Shorthand or adjectivize common countries
		if (code === 'US') country = 'a US';
		if (code === 'GB') country = 'a UK';
		if (code === 'CA') country = 'a Canadian';
		if (code === 'AU') country = 'an Australian';

		this.label.html(`
			Don&rsquo;t have ${country} phone number?
			Click here to change your country&hellip;
		`);
	}

	// The worker's phone verdict for a field in this form (SC-616). A caution
	// on a kept number usually means the mask read foreign digits as the
	// selected country's, so the prompt carries it and asks to be clicked.
	// The reason for a refusal is already in the field; the prompt only
	// draws the eye to the way out.
	showVerdict(verdict) {
		if (!this.isVisible) return;
		const caution = verdict.accept && verdict.message;

		this.root.toggleClass('is-warning', !verdict.accept || !!caution);
		if (!caution) return this.setLabel();

		this.label.empty()
			.append($('<span />').text(verdict.message + ' '))
			.append($('<strong />').html('Change your country&hellip;'));
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.form = this.root.closest('form');
		this.label = this.root.find('.gs-FormLocale-detectedCountry');
	}

	gsOnInit() {
		this.countries = $('.gs-FormLocale').gs(0);

		// Reachable and operable from the keyboard, not only by mouse.
		this.root.attr({ role: 'button', tabindex: '0' });
		this.root.on('click', () => this.showCountryList());
		this.root.on('keydown', evt => {
			if (evt.key != 'Enter' && evt.key != ' ') return;
			evt.preventDefault();
			this.showCountryList();
		});

		this.form.on('gs:phoneVerdict.localePrompt', (evt, verdict) => this.showVerdict(verdict));
		this.detectCountry();
	}

	gsOnDestroy() {
		this.root.off();
		this.form.off('gs:phoneVerdict.localePrompt');
	}
}
